import { Component, Input, OnInit, EventEmitter, Output }                                             from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl }                                 from '@angular/forms';
import { FmRelease }                                                                                  from '../../../../models/program/fm-release';
import { UtilsService }                                                                               from '../../../../shared/utils.service';

@Component({
  selector: 'app-edit-fm-releases',
  templateUrl: './edit-fm-releases.component.html',
  styleUrls: ['./edit-fm-releases.component.less'],
  providers: [UtilsService]
})

export class EditFmReleasesComponent implements OnInit{
  @Input() fms: FmRelease[];
  @Input() currentReleases: FmRelease[];
  @Output() update: EventEmitter<FmRelease[]> = new EventEmitter<FmRelease[]>();
  errors: string[] = [];

  releaseForm: FormGroup;
  loaded: boolean;

  constructor(
    private _fb: FormBuilder,
    private utils: UtilsService
  ) { 
  }

  // Return a formArray
  ngOnInit(): void {    
    this.releaseForm = this.defaulReleaseForm;
    this.setReleaseTemplates();
    this.setReleaseDates();
    this.releaseForm.valueChanges.subscribe(changes => {
      this.update.emit(changes.fm_releases)
      this.currentReleases = changes.fm_releases;
    })
    this.loaded = true;
  }

  get defaulReleaseForm() {
    return this._fb.group({
      fm_releases: this._fb.array([])
    });
  }

  comingSoon(fm: FormGroup): boolean {
     return fm.controls['release'].value === false;
  }

  comingNever(fm: FormGroup): boolean {
     return fm.controls['release'].value === undefined;
  }

  resetRelease(index: number): void {
    this.setFmReleaseDate(null, index)
  }

  setReleaseTemplates(): void {
    this.fms.forEach((fm) => {
      this.addFmReleaseForm(this.buildFmReleaseForm(fm))
    });
  }

  setReleaseDates(): void {
    this.currentReleases.forEach((r, index) => {
      let fmIndex = this.fms.findIndex(fm => r.id == fm.id);
      this.setFmReleaseDate(r.release, fmIndex);
    });
  }

  noRelease(index: number): void {
    this.setFmReleaseDate(undefined, index)
  }

  releaseNow(index: number): void {
    let fullDateString = this.utils.createNowReleaseString();
    this.setFmReleaseDate(fullDateString, index);
  }

  releaseLater(index: number): void {
    // These field manuals should appear as "Coming Soon" to users
    this.setFmReleaseDate(false, index);
  }

  setFmReleaseDate(dateTimeString: string | false | undefined, index: number) {
    let fmArray: FormArray = <FormArray>this.releaseForm.controls['fm_releases'];
    let fmGroup: FormGroup = <FormGroup>fmArray.at(index)
    fmGroup.markAsDirty();
    fmGroup.controls['release'].markAsDirty();
    fmGroup.controls['release'].setValue(dateTimeString);
  }

  buildFmReleaseForm(fm: {id, title, release?}): FormGroup {
    return this._fb.group({
      id: [fm.id, Validators.required],
      release: [fm.release],
      title: [fm.title]
    });
  }

  addFmReleaseForm(releaseForm: FormGroup): void {
    const control: FormArray = <FormArray>this.releaseForm.controls['fm_releases'];
    control.push(releaseForm);
  }
  
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/edit-fm-releases/edit-fm-releases.component.ts